import * as Select from '@radix-ui/react-select';

/**
 * Radix UI Select dropdown for column faceted filters.
 *
 * @param {Array}    options     Array of { value, label } objects
 * @param {string}   value       Currently selected value ('' = all)
 * @param {Function} onChange    Called with the new value string
 * @param {string}   placeholder Shown when nothing is selected
 * @param {boolean}  disabled    When true, the dropdown is inert and greyed out
 */
const ALL = '__all__';

export default function SelectFilter( {
	options,
	value,
	onChange,
	placeholder = 'Todos',
	disabled = false,
} ) {
	const isActive = !! value;

	return (
		<Select.Root
			value={ value || ALL }
			onValueChange={ ( v ) => onChange( v === ALL ? '' : v ) }
			disabled={ disabled }
		>
			<Select.Trigger
				className={ [
					'inline-flex items-center gap-1 px-3 py-2 border-2 border-black rounded-none shadow-sm focus:outline-none',
					disabled
						? 'opacity-50 cursor-not-allowed'
						: 'cursor-pointer hover:bg-yellow data-[state=open]:bg-yellow',
					isActive
						? 'bg-white'
						: 'bg-gray-light data-[placeholder]:text-gray',
				].join( ' ' ) }
			>
				<Select.Value placeholder={ placeholder } />
				<Select.Icon className="ml-1 text-xs">▾</Select.Icon>
			</Select.Trigger>

			<Select.Portal>
				<Select.Content className="z-50 bg-white border-2 border-black shadow-lg rounded-none overflow-hidden">
					<Select.Viewport>
						<Select.Item
							value={ ALL }
							className="px-3 py-2 cursor-pointer outline-none data-[highlighted]:bg-yellow data-[highlighted]:text-green-dark"
						>
							<Select.ItemText>{ placeholder }</Select.ItemText>
						</Select.Item>

						{ options.map( ( opt ) => (
							<Select.Item
								key={ opt.value }
								value={ opt.value }
								className="px-3 py-2 cursor-pointer outline-none data-[highlighted]:bg-yellow data-[highlighted]:text-green-dark"
							>
								<Select.ItemText>{ opt.label }</Select.ItemText>
							</Select.Item>
						) ) }
					</Select.Viewport>
				</Select.Content>
			</Select.Portal>
		</Select.Root>
	);
}
